module.exports = __webpack_public_path__ + "static/media/icn_lourney_end.73edf774.svg";